const RESPONSIVE = {
  MOBILE_BREAKPOINT: 768,
  DESKTOP_BREAKPOINT: 1200,
};

export default RESPONSIVE;
